// #2287 (spec 2110 §29) — the first-activation acknowledgement of the DPA
// amendments, for NEW employers only (opened from 20.9.2026).
//
// Callables, not document reads/writes: the acknowledgements live in
// `dpaAmendmentAcceptances`, which `firestore.rules` never opens to a client.
// See `functions/employers/dpaAmendment.js`.

import { httpsCallable } from './app'

/**
 * @returns {Promise<{required: boolean, version?: string, text?: string, contentHash?: string,
 *   accepted?: boolean, reason?: string}>}
 *   `required: true` only for an employer admin of a new employer that has not
 *   yet acknowledged the current amendment version; then `version` and `text`
 *   are what to show. Rejects (`failed-precondition`) when the document cannot
 *   be shown truthfully.
 */
export async function getDpaAmendmentStatus() {
  const result = await httpsCallable('getDpaAmendmentStatus')({})
  return result?.data ?? { required: false }
}

/**
 * @param {object} params
 * @param {string} params.version The version shown next to the checkbox.
 * @returns {Promise<{success: boolean, version: string, alreadyAccepted: boolean}>}
 */
export async function acceptDpaAmendment({ version }) {
  const result = await httpsCallable('acceptDpaAmendment')({ version, confirmed: true })
  return result?.data ?? {}
}
